import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link, createFileRoute } from '@tanstack/react-router';
import { MailIcon } from '@ui/custom-icons';
import { Button } from '@ui/primitives/button';
import { Card, CardContent } from '@ui/primitives/card';
import { z } from 'zod';
import { StandaloneLayout } from '../../standalone-layout';
const verifyEmailSearchSchema = z.object({
    email: z.string().optional()
});
export const Route = createFileRoute('/auth/verify-email')({
    validateSearch: verifyEmailSearchSchema,
    component: VerifyEmailPage
});
function VerifyEmailPage() {
    const { email } = Route.useSearch();
    return /*#__PURE__*/ _jsx(StandaloneLayout, {
        children: /*#__PURE__*/ _jsx(Card, {
            className: "w-full max-w-md bg-card rounded-2xl",
            children: /*#__PURE__*/ _jsxs(CardContent, {
                className: "flex flex-col items-center gap-5 p-8 text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "rounded-full bg-primary/10 p-4",
                        children: /*#__PURE__*/ _jsx(MailIcon, {
                            width: 40,
                            height: 40,
                            className: "text-primary"
                        })
                    }),
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-2xl font-bold tracking-tight",
                        children: "Verify Your Email"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-muted-foreground leading-relaxed text-sm",
                        children: email ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "We sent a verification link to ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "font-semibold text-foreground",
                                    children: email
                                }),
                                ". Click the link in your inbox to continue."
                            ]
                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: "Please check your inbox for a verification email and click the link to continue."
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-muted-foreground/80 text-xs",
                        children: "Didn't receive the email? Check your spam or junk folder."
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        asChild: true,
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "/login",
                            children: "Back to Login"
                        })
                    })
                ]
            })
        })
    });
}
